// Formatacoes compartilhadas da tela de licencas.

// versao em inteiro XX*10000+YY*100+ZZ (padrao da casa) -> "10.9.1"
export function formataVersao(numero) {
  const n = Number(numero) || 0;
  if (!n) {
    return '';
  }
  return `${Math.floor(n / 10000)}.${Math.floor(n / 100) % 100}.${n % 100}`;
}

export function formataDataHora(valor) {
  return valor ? new Date(valor).toLocaleString('pt-BR') : '';
}

// 'yyyy-MM-dd' -> 'dd/MM/yyyy' (sem passar por Date: evita o deslocamento de fuso)
export function formataData(valor) {
  if (!valor) {
    return '';
  }
  const [ano, mes, dia] = String(valor)
    .substring(0, 10)
    .split('-');
  return `${dia}/${mes}/${ano}`;
}

// licenca_evento.tipo
export const TIPOS_EVENTO = {
  1: 'Ativação',
  2: 'Renovação',
  3: 'Revogada (nova ativação)',
  4: 'Revogada (manual)',
  5: 'Token divergente',
  6: 'Bloqueio por trocas',
  7: 'Desbloqueio',
  8: 'Prorrogação',
};

export const OPCOES_SITUACAO = [
  { label: 'Ativas', value: 'A' },
  { label: 'Revogadas', value: 'R' },
  { label: 'Todas', value: '' },
];
